import { cn } from "@/lib/utils";
import { EmptyState } from "./EmptyState";
import { Inbox } from "lucide-react";

// Tabela de dados reutilizável (dark, densa, hover, coluna de ações sticky opcional).
export const DataTable = ({ columns, rows, keyField = "id", onRowClick, empty, className, testid = "data-table" }) => {
  if (!rows || rows.length === 0) {
    return empty || <EmptyState icon={Inbox} title="Nenhum registro" description="Nada para exibir por aqui ainda." />;
  }
  return (
    <div className={cn("w-full overflow-x-auto rounded-xl border border-line bg-surface", className)} data-testid={testid}>
      <table className="w-full min-w-[640px] border-collapse text-sm">
        <thead>
          <tr className="border-b border-line">
            {columns.map((c) => (
              <th
                key={c.key}
                className={cn(
                  "px-4 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wider text-muted-foreground",
                  c.align === "right" && "text-right",
                  c.align === "center" && "text-center",
                  c.thClassName,
                )}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr
              key={row[keyField] ?? i}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              data-testid={`${testid}-row-${row[keyField] ?? i}`}
              className={cn(
                "border-b border-line/60 transition-colors last:border-0",
                onRowClick && "cursor-pointer hover:bg-white/[0.03]",
              )}
            >
              {columns.map((c) => (
                <td
                  key={c.key}
                  className={cn(
                    "px-4 py-3 align-middle text-foreground/90",
                    c.align === "right" && "text-right",
                    c.align === "center" && "text-center",
                    c.tdClassName,
                  )}
                >
                  {c.render ? c.render(row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
